import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import PlaybookMap from '../components/PlaybookMap';

export default function TradeWalkthroughPage() {
  const { colors } = useTheme();
  const navigate   = useNavigate();

  return (
    <div className="flex flex-col pb-10" style={{ backgroundColor: colors.background }}>

      {/* Header */}
      <div className="flex items-center gap-3 px-4 pt-4 pb-5">
        <button
          onClick={() => navigate('/learning')}
          className="p-1.5 rounded-lg"
          style={{ background: 'rgba(255,255,255,0.06)', color: colors.primaryText }}
        >
          <ArrowLeft size={18} />
        </button>
        <div>
          <p style={{ fontSize: 11, fontWeight: 900, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#06b6d4', marginBottom: 2 }}>
            Learning
          </p>
          <p style={{ fontSize: 18, fontWeight: 800, color: '#eceef5', letterSpacing: '-0.02em', lineHeight: 1.1 }}>
            Trade Walkthrough
          </p>
        </div>
      </div>

      {/* Decision Engine intro */}
      <div style={{ padding: '0 16px 4px' }}>
        <p style={{ fontSize: 11, fontWeight: 900, textTransform: 'uppercase', letterSpacing: '0.06em', color: '#f59e0b', marginBottom: 4 }}>
          Decision Engine
        </p>
        <p style={{ fontSize: 17, fontWeight: 800, color: '#eceef5', letterSpacing: '-0.02em', lineHeight: 1.2 }}>
          Run before every trade
        </p>
        <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginTop: 4 }}>
          5 questions. Grades your setup. Tells you exactly what to do.
        </p>
      </div>

      <PlaybookMap colors={colors} navigate={navigate} />
    </div>
  );
}
